import { createReducer } from "reduxsauce"
import createActions from "helpers/actionCreator"
import { omit, keysIn, forEach } from "lodash"
import moment from "moment"
import { post } from "api"
import { log } from "helpers/logger"
import { takeLatest, call } from "redux-saga/effects"
import { Types as WatchlistsMenuTypes } from "modules/watchlists-menu/model"
import { Types as SecuritiesFinderTypes } from "modules/securities-finder/model"

export const { Types, Creators } = createActions("ompnt/modules/securities-finder-results/", {
  toggleColumnSelector: [],
  selectSecurity: ["security", "selected"],
  selectAllSecurities: ["securities", "selected"],
  addedToWatchlist: [],
  searchColumn: ["column", "search"],
  toggleWatchlistsMenu: [],
  download: ["account", "modelId", "filter", "sort", "selectedColumns", "date", "currency"],
})

const DEFAULT_STATE = {
  watchlistsMenuVisible: false,
  columnSelectorOpen: false,
  selectedSecurities: {
    total: 0,
    securities: {},
  },
  columnSearches: {},
}

function handleToggleWatchlistsMenu(state) {
  return { ...state, watchlistsMenuVisible: !state.watchlistsMenuVisible }
}

function handleSelectSecurity(state, { security }) {
  const selectedSecurities = { securities: { ...state.selectedSecurities.securities } }

  if (selectedSecurities.securities[security.id]) {
    selectedSecurities.securities = omit(selectedSecurities.securities, security.id)
  } else {
    selectedSecurities.securities[security.id] = {
      assetClass: security.assetClass,
      ticker: security.ticker,
      id: security.id,
      mic: security.mic,
      internalId: security.internalId,
      modelProviderId: security.modelProviderId,
    }
  }

  selectedSecurities.total = keysIn(selectedSecurities.securities).length

  return { ...state, selectedSecurities }
}

function handleSelectAllSecurities(state, { securities, selected }) {
  const selectedSecurities = { securities: { ...state.selectedSecurities.securities } }

  forEach(securities, security => {
    if (!selected) {
      selectedSecurities.securities = omit(selectedSecurities.securities, security.id)
    } else if (!selectedSecurities.securities[security.id]) {
      selectedSecurities.securities[security.id] = {
        assetClass: security.assetClass,
        ticker: security.ticker,
        id: security.id,
        mic: security.mic,
        modelProviderId: security.modelProviderId,
        internalId: security.internalId,
      }
    }
  })

  selectedSecurities.total = keysIn(selectedSecurities.securities).length

  return { ...state, selectedSecurities }
}

function handleAddedToWatchlist(state) {
  return { ...state, selectedSecurities: { total: 0, securities: {} } }
}

function handleToggleColumnSelector(state) {
  return { ...state, columnSelectorOpen: !state.columnSelectorOpen }
}

function handleSearchColumn(state, { column, search }) {
  const searches = { ...state.columnSearches }
  searches[column] = search
  return { ...state, columnSearches: searches }
}

function handleResetSelectedSecurities(state) {
  return {
    ...state,
    selectedSecurities: {
      total: 0,
      securities: {},
    },
  }
}

export default createReducer(DEFAULT_STATE, {
  [Types.TOGGLE_COLUMN_SELECTOR]: handleToggleColumnSelector,
  [Types.SELECT_SECURITY]: handleSelectSecurity,
  [Types.SELECT_ALL_SECURITIES]: handleSelectAllSecurities,
  [Types.SEARCH_COLUMN]: handleSearchColumn,
  [SecuritiesFinderTypes.TOGGLE_FACET]: handleResetSelectedSecurities,
  [SecuritiesFinderTypes.UPDATE_FILTERS]: handleResetSelectedSecurities,
  [SecuritiesFinderTypes.SET_DATE]: handleResetSelectedSecurities,
  [WatchlistsMenuTypes.ADD_TO_WATCHLISTS_SUCCESS]: handleAddedToWatchlist,
  [Types.TOGGLE_WATCHLISTS_MENU]: handleToggleWatchlistsMenu,
})

function* handleDownload({ account, modelId, filter, sort, selectedColumns, date, currency }) {
  try {
    yield call(post, `/api/${account}/m/${modelId}/download/search`, { filter,
      sort,
      selectedColumns,
      date,
      currency,
      fileName: `market_securities - ${moment().format("MMM D, YYYY @ h:mm A")}` })
  } catch (err) {
    log(err)
  }
}

export function* saga() {
  yield takeLatest(Types.DOWNLOAD, handleDownload)
}
